import store from '@/store/store';
import { Options, Vue } from 'vue-class-component';

@Options({
	name: 'ModalComponent',
	props: {
		id: { type: String, default: '123' },
	},
})
export default class ModalComponent extends Vue {
	id?: string; // use to trigger modal with event, ex. on element
	public isActive = false;
	public modalExiting = false;

	// LIFECYCLE
	created() {
		document.addEventListener('keyup', this.handleKeyup);
		document.addEventListener('keydown', this.handleKeyup);
		store.subscribeAction((action, state) => {
			if (action.type === 'toggleModal') {
				if (this.id === action.payload.id) {
					this.toggleModal(action.payload.isActive);
				}
			}
		});
	}

	mounted() {
		this.modalExiting = false;
	}

	beforeUnmount() {
		document.removeEventListener('keyup', this.handleKeyup);
		document.removeEventListener('keydown', this.handleKeyup);
	}

	// METHODS
	public toggle(val: boolean, event?) {
		event?.preventDefault();
		let timeout = 0;
		if (!val) {
			timeout = 500;
			this.modalExiting = true;
		}
		setTimeout(() => {
			store.dispatch('toggleModal', { id: this.id, show: val });
		}, timeout);
	}

	private toggleModal(val: boolean = false) {
		val === undefined ? (this.isActive = !this.isActive) : (this.isActive = val);
		if (this.isActive) {
			this.modalExiting = false;
		}
	}

	private handleKeyup(e: any) {
		// make sure key event isn't bubbled to page below
		e?.preventDefault();
		e?.stopPropagation();

		if (e?.keyCode === 27 && this.isActive) {
			// escape
			store.dispatch('toggleModal', { id: this.id, show: false });
		}
	}
	// COMPUTED
	get hasFooterSlot() {
		return !!(this as any).$slots.footer;
	}
}
